import HrLayout from "./layouts/HrLayout";
import PhLayout from "./layouts/PhLayout";
import DefaultLayout from "./layouts/DefaultLayout";

import { Login, SSOLogin } from "./pages";
/* Hotel Photography Lead */
import HrFirstLogin from "./pages/hotelRepresentative/HrFirstLogin";
import HrDashboard from "./pages/hotelRepresentative/HrDashboard";
import GetCertified from "./pages/GetCertified";
import PhotoshootRequest from "./pages/hotelRepresentative/PhotoshootRequest";
import PhotoshootDetails from "./pages/PhotoshootDetails";
/* Photographer */
import PhDashboard from "./pages/photographer/PhDashboard";
import PhPhotoshootRequest from "./pages/photographer/PhPhotoshootRequest";
import PhManagePhotoshoots from "./pages/photographer/PhManagePhotoshoots";
import PhViewFeedback from "./pages/photographer/PhViewFeedback";
import ChangePassword from "./pages/photographer/ChangePassword";
import ResetPassword from "./pages/photographer/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";

import { Dashboard } from "./pages";

import Resources from "./pages/Resources";
import Archives from "./pages/Archives";
import RecceViewer from "./pages/RecceViewer";
import Utils from "./Utils";

// Helper to pick layout based on user type
function getUserLayout() {
  const user = Utils.getUserData && Utils.getUserData();
  if (user?.isHR || user?.isAMT) return HrLayout;
  if (user?.isPG || user?.isHO) return PhLayout;
  return DefaultLayout;
}

const CustomRoutes = [
  {
    path: "/resources",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: Resources,
  },
  {
    path: "/resource-hub",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: Resources,
  },
  {
    path: "/archives",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: Archives,
  },
  {
    path: "/sso",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: SSOLogin,
  },
  {
    path: "/dashboard",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: Dashboard,
  },
  {
    path: "/login",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: Login,
  },
  {
    path: "/",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: Login,
  },
  {
    path: "/forgot-password/:userType",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: ForgotPassword,
  },
  {
    path: "/reset-password/:token",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: ResetPassword,
  },
  /* Routing for Hotel Photography Lead */
  {
    path: "/hotel-representative-first-login",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: HrFirstLogin,
  },

  {
    path: "/get-certified",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: GetCertified,
  },
  {
    path: "/photoshoot-request",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: PhotoshootRequest,
  },
  {
    path: "/photoshoot-details/:id",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: PhotoshootDetails,
  },
  /* Routing for Photographer */

  {
    path: "/photoshoot-request/:id",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: PhPhotoshootRequest,
  },
  {
    path: "/photographer-manage-photoshoots",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhManagePhotoshoots,
  },
  {
    path: "/photoshoot-recce/:pid/:mode/:rfname",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: RecceViewer,
  },
  {
    path: "/view-feedback/:psid/:origid",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: PhViewFeedback,
  },
  {
    path: "/view-feedback/:psid/:origid/:fname",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: PhViewFeedback,
  },
  {
    path: "/change-password",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: ChangePassword,
  },
];

export default CustomRoutes;
